import { call, put, takeEvery } from 'redux-saga/effects';
import { gcApi } from 'config/axios';

import {
    FETCH_WELLNESS_GOAL,
    FETCH_WELLNESS_GOAL_FAIL,
    FETCH_WELLNESS_GOAL_FETCHING,
    FETCH_WELLNESS_GOAL_SUCCESS
} from 'actions/wellnessGoals';

import {
    CREATING_GOAL,
    CREATE_GOAL_SUCCESS,
    CREATE_GOAL_FAIL,
    UPDATE_GOAL,
    UPDATING_GOAL,
    UPDATE_GOAL_SUCCESS,
    UPDATE_GOAL_FAIL
} from 'actions/ActionTypes';

import { CREATE_GOAL_REQUEST, DELETE_GOAL_REQUEST, FETCH_GOALS, FETCH_ALL_GOALS } from '../actions/ActionTypes';
import { onCreateGoal, onDeleteGoal, receiveAllGoals, receiveGoals, requestGoals } from '../actions';
import { handlingErrorCallback, handlingSuccessCallback } from './sagasUtils';

import { toQueryString } from 'utils/UrlUtil';

export const GOALS_DEFAULTS = {
    start: 1,
    limit: 100,
    sortOrder: 'desc'
};

export function* fetchWellnessGoal(action) {
    try {
        yield put({
            type: FETCH_WELLNESS_GOAL_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/goal-service/goal/user/${action.userGoalType}/${action.trackingPeriodType}`
        );

        yield put({
            type: FETCH_WELLNESS_GOAL_SUCCESS,
            userGoalType: action.userGoalType,
            trackingPeriodType: action.trackingPeriodType,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_WELLNESS_GOAL_FAIL,
            userGoalType: action.userGoalType,
            trackingPeriodType: action.trackingPeriodType,
            data: {}
        });
    }
}

export function* fetchGoalsSaga({
    status,
    start = GOALS_DEFAULTS.start,
    limit = GOALS_DEFAULTS.limit,
    sortOrder = GOALS_DEFAULTS.sortOrder,
    replace = false
}) {
    const queryString = toQueryString({
        status,
        start,
        limit,
        sortOrder
    });
    try {
        yield put(requestGoals());
        const response = yield gcApi.get(`/goal-service/goal/goals${queryString}`);
        yield put(receiveGoals(response.data, status, start, limit, sortOrder, replace));
    } catch (e) {}
}

export function* fetchAllGoalsSaga({
    callback,
    start = GOALS_DEFAULTS.start,
    limit = GOALS_DEFAULTS.limit,
    sortOrder = GOALS_DEFAULTS.sortOrder
}) {
    const pastQueryString = toQueryString({
        status: 'past',
        start,
        limit,
        sortOrder
    });

    try {
        yield put(requestGoals());
        const response = {
            active: (yield gcApi.get(`/goal-service/goal/goals?status=active`)).data,
            future: (yield gcApi.get(`/goal-service/goal/goals?status=future`)).data,
            past: (yield gcApi.get(`/goal-service/goal/goals${pastQueryString}`)).data
        };
        yield put(receiveAllGoals(response, start, limit, sortOrder));
        yield call(handlingSuccessCallback, callback, response);
    } catch (e) {
        yield call(handlingErrorCallback, callback, e);
    }
}

export function* deleteGoalSaga({ goalId, callback }) {
    try {
        yield put(onDeleteGoal(goalId));
        const response = yield gcApi.delete(`/goal-service/goal/goal/${goalId}`);
        yield call(handlingSuccessCallback, callback, response);
    } catch (e) {
        yield call(handlingErrorCallback, callback, e);
    }
}

export function* createGoalSaga({ data, callback }) {
    try {
        yield put(onCreateGoal());
        yield put({
            type: CREATING_GOAL
        });
        const response = yield gcApi.post(`/goal-service/goal/goal`, data);
        yield put({
            type: CREATE_GOAL_SUCCESS
        });
        yield call(handlingSuccessCallback, callback, response);
    } catch (e) {
        yield put({
            type: CREATE_GOAL_FAIL
        });
        yield call(handlingErrorCallback, callback, e);
    }
}

export function* updateGoalSaga({ goalId, data, callback }) {
    try {
        yield put({
            type: UPDATING_GOAL,
            goalId,
            data
        });
        const response = yield gcApi.put(`/goal-service/goal/goal/${goalId}`, data);
        yield put({
            type: UPDATE_GOAL_SUCCESS,
            goalId,
            data
        });
        yield call(handlingSuccessCallback, callback, response);
    } catch (e) {
        yield put({
            type: UPDATE_GOAL_FAIL,
            data,
            goalId
        });
        yield call(handlingErrorCallback, callback, e);
    }
}

export const wellnessGoalSagas = [
    takeEvery(FETCH_WELLNESS_GOAL, fetchWellnessGoal),
    takeEvery(FETCH_GOALS, fetchGoalsSaga),
    takeEvery(FETCH_ALL_GOALS, fetchAllGoalsSaga),
    takeEvery(DELETE_GOAL_REQUEST, deleteGoalSaga),
    takeEvery(CREATE_GOAL_REQUEST, createGoalSaga),
    takeEvery(UPDATE_GOAL, updateGoalSaga)
];
